// extracted by mini-css-extract-plugin
export default {"title":"_2adeb20d10","bld":"fc13a4b91a"};